import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { EmployeeRecord } from 'src/app/shared/models/EmployeeRecord.model';
import { LaborScheduleEntry } from 'src/app/shared/models/laborScheduling/LaborScheduling.model';

@Component({
	selector: 'app-employee-schedule-event',
	templateUrl: './employee-schedule-event.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class EmployeeScheduleEventComponent implements OnInit, OnChanges {
	@Input() entry: LaborScheduleEntry;
	@Output() entryChange = new EventEmitter<LaborScheduleEntry>();

	@Output() deleteEntryChange = new EventEmitter<LaborScheduleEntry>();
	@Output() saveEntryChange = new EventEmitter<LaborScheduleEntry>();

	@Input() scheduleStartDate: string;

	@Input() employeeRecord: EmployeeRecord;

	entryStartTime: Date;
	entryEndTime: Date;
	hoursMinutes: string;

	constructor(public app: AppService) {}
	ngOnChanges(changes: SimpleChanges): void {}

	ngOnInit(): void {
		if (!this.entry.startDateTime) {
			this.entry.startDateTime = this.app.moment(this.scheduleStartDate).add(this.entry.startDay, 'day').toDate();
		}
		this.entryStartTime = this.app.moment(this.entry.startDateTime).toDate();
		if (!this.entry.endDateTime) {
			this.entry.endDateTime = this.entry.startDateTime;
		}
		this.entryEndTime = this.app.moment(this.entry.endDateTime).toDate();
		this.calculateTime();
	}

	cancel() {
		this.entryChange.emit(undefined);
		this.entry = undefined;
	}

	calculateCostValues() {
		const jobPayRate = this.entry.employee.jobs.find((i) => i.id === this.entry.jobId).payRate;
		const startMoment = this.app.moment(this.entry.startDateTime);
		const endMoment = this.app.moment(this.entry.endDateTime);
		const durationOfMinutes = endMoment.diff(startMoment, 'minute');

		this.entry.cost = (jobPayRate / 60) * durationOfMinutes;
		this.entry.minutes = durationOfMinutes;

		this.hoursMinutes = this.app.moment.duration(durationOfMinutes, 'minutes').format('h [hrs], m [min]');
	}

	calculateTime() {
		const momentStart = this.app.moment(this.entryStartTime);
		const momentEnd = this.app.moment(this.entryEndTime);

		if (momentStart.isAfter(momentEnd)) {
			momentEnd.add(1, 'day');
		}

		this.entry.startDateTime = momentStart.format();
		this.entry.endDateTime = momentEnd.format();

		this.calculateCostValues();
	}

	delete() {
		this.deleteEntryChange.emit(this.entry);
		this.entryChange.emit(undefined);
		this.entry = undefined;
	}

	deleteDisabled(): boolean {
		if (!this.entry.externalId) {
			return true;
		}
		return false;
	}

	save() {
		this.calculateTime();
		!this.entry.externalId && (this.entry.externalId = this.app.uuidv4());
		this.saveEntryChange.emit(this.entry);
		this.entryChange.emit(undefined);
		this.entry = undefined;
	}

	savePrompt() {
		if (this.validateStartAndEndTimeOffset()) {
			this.app.confirmation.confirm({
				message: `You've scheduled ${this.entry.employee.nickName} for more than 12 hours. Continue?`,
				accept: async () => {
					this.save();
				},
				reject: async () => {
					this.app.confirmation.close();
				},
			});
		} else {
			this.save();
		}
	}

	saveDisabled(): boolean {
		if (!this.entry.startDateTime || !this.entry.endDateTime || !this.entry.jobId || this.entry.startDateTime === this.entry.endDateTime) {
			return true;
		}
		if (this.entry.startDateTime > this.entry.endDateTime) {
			return true;
		}
		return false;
	}

	validateStartAndEndTimeOffset() {
		const momentStart = this.app.moment(this.entry.startDateTime);
		const momentEnd = this.app.moment(this.entry.endDateTime);
		if (momentEnd.diff(momentStart, 'hours') > 12) {
			return true;
		}
		return false;
	}
}
